import actions from "~/shared/actions";

export const closeEkstraInnbetalingMessage = () => (dispatch) => dispatch(actions.closeEkstraInnbetalingMessage());

export const closeAvkastningshistorikk = () => (dispatch) => dispatch(actions.closeAvkastningshistorikk());
